import { UIRouterModule } from "@uirouter/angular";
import { NgModule } from "@angular/core";
import over from "lodash.over";
import { employeeStates, states as ng1States, teamStates } from "@gtmhub/people/people.states";
import { loadChildFutureStatesConfig, registerChildFutureStateFactories, replaceWithFutureStatesConfig } from "@webapp/core/routing/routing.utils";

const states: unknown[] = [...ng1States];

registerChildFutureStateFactories({ teamStates, employeeStates });

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states,
      config: over(replaceWithFutureStatesConfig(["gtmhub.employees", "gtmhub.teams"]), loadChildFutureStatesConfig),
    }),
  ],
})
export class PeopleRoutingModule {}
